import { useEffect, useState } from "react"

const IDLE_TIMEOUT_MS = 500

export function useIdleReady(enabled: boolean): boolean {
	const [ready, setReady] = useState(false)

	useEffect(() => {
		if (!enabled) {
			setReady(false)
			return
		}

		if (ready) {
			return
		}

		let cancelled = false

		const markReady = () => {
			if (!cancelled) {
				setReady(true)
			}
		}

		if ("requestIdleCallback" in window) {
			const idleId = window.requestIdleCallback(markReady, {
				timeout: IDLE_TIMEOUT_MS,
			})

			return () => {
				cancelled = true
				window.cancelIdleCallback(idleId)
			}
		}

		const timeoutId = globalThis.setTimeout(markReady, 0)

		return () => {
			cancelled = true
			globalThis.clearTimeout(timeoutId)
		}
	}, [enabled, ready])

	return ready
}
